import React from "react";
const Context = React.createContext(undefined);
export default Context;
